import { render, staticRenderFns } from "./noPricingCard.vue?vue&type=template&id=767dd3be&scoped=true&"
import script from "./noPricingCard.vue?vue&type=script&lang=js&"
export * from "./noPricingCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767dd3be",
  null
  
)

export default component.exports